/**
 * @generated SignedSource<<de60d44e44f2526508b65866eba18531>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { DateTime } from "@/common/relayCustomScalar";
import { Semver } from "@/common/relayCustomScalar";
import { FragmentRefs } from "relay-runtime";
export type WorkspaceScaffoldVersionFragment$data = {
  readonly id: string;
  readonly latest: boolean;
  readonly publishedAt: DateTime | null | undefined;
  readonly version: Semver;
  readonly viewerCanEdit: boolean;
  readonly " $fragmentSpreads": FragmentRefs<"WorkspaceVersionCloneButtonVersionFragment">;
  readonly " $fragmentType": "WorkspaceScaffoldVersionFragment";
};
export type WorkspaceScaffoldVersionFragment$key = {
  readonly " $data"?: WorkspaceScaffoldVersionFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"WorkspaceScaffoldVersionFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "WorkspaceScaffoldVersionFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "version",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "publishedAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "latest",
      "storageKey": null
    },
    {
      "alias": "viewerCanEdit",
      "args": [
        {
          "kind": "Literal",
          "name": "action",
          "value": "UPDATE_WORKSPACE_VERSION"
        }
      ],
      "kind": "ScalarField",
      "name": "viewerCan",
      "storageKey": "viewerCan(action:\"UPDATE_WORKSPACE_VERSION\")"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "WorkspaceVersionCloneButtonVersionFragment"
    }
  ],
  "type": "WorkspaceVersion",
  "abstractKey": null
};

(node as any).hash = "c464df76a4d2cd2dd02c881490276173";

export default node;
